import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

type PocOperationalStatusResponse = {
  user?: {
    chatHashCode?: string
    username?: string
  }
  seller?: {
    id?: string | number
    name?: string
    status?: string
    document?: string
    address?: {
      city?: string
      countryCode?: string
      provinceCode?: string
      neighborhood?: string
    }
  }
}

export const POC_OPERATIONAL_STATUS = gql`
  query sellerOperationalStatus {
    user {
      chatHashCode
    }
    seller {
      id
      name
      status
      address {
        city
        countryCode
        provinceCode
        neighborhood
      }
      document
    }
  }
`

export const POC_OPERATIONAL_STATUS_KEY = 'usePocOperationalStatus'

export const usePocOperationalStatus = () =>
  useQuery<PocOperationalStatusResponse>({
    queryKey: [POC_OPERATIONAL_STATUS_KEY],
    queryFn: variables => client.request(POC_OPERATIONAL_STATUS, variables),
  })
